export enum LicenseType {
  PLAYER = 'PLAYER'
}

export const LicenseTypeLabel = {
  [LicenseType.PLAYER]: 'Player'
};
